import { IAcceptedDocument } from 'APIPackage/DictionariesModule/interfaces/IAcceptedDocument';

import { makeCreateDictionarySelectOption } from './makeCreateDictionarySelectOption';

export const createDictionaryAcceptedDocumentSelectOption = makeCreateDictionarySelectOption<IAcceptedDocument>(
  'id',
  'title',
);
